<template>
  <v-dialog v-model="open" width="560px">
    <v-card width="560px">
      <v-card-text>
        <v-row no-gutters class="mt-6">
          <v-col cols="10" class="d-flex flex-row align-center justify-start">
            <span class="body-bold-medium textType3--text">{{
              isEdit
                ? $t('message.pages.videoPlayerForm.editIntegration')
                : $t('message.pages.videoPlayerForm.newIntegration')
            }}</span>
          </v-col>
          <v-col
            style="height: 25px"
            cols="2"
            class="d-flex flex-row align-start justify-end"
          >
            <span style="cursor: pointer" @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </span>
          </v-col>
          <v-col cols="12">
            <span class="body-regular-smaller textType6--text">
              {{
                connectLoading
                  ? $t('message.pages.videoPlayerForm.testingNewIntegration')
                  : connectSuccess
                  ? `${$t(
                      'message.pages.videoPlayerForm.integrationSuccessPart1'
                    )} ${getIntegrationName(platform)} ${$t(
                      'message.pages.videoPlayerForm.integrationSuccessPart2'
                    )}`
                  : connectError
                  ? `${$t(
                      'message.pages.videoPlayerForm.integrationFailedPart1'
                    )} ${getIntegrationName(platform)}. ${$t(
                      'message.pages.videoPlayerForm.integrationFailedPart2'
                    )}`
                  : isEdit
                  ? $t('message.pages.videoPlayerForm.editPlatform')
                  : $t('message.pages.videoPlayerForm.selectPlatform')
              }}
            </span>
          </v-col>
          <v-col
            v-if="connectLoading || connectSuccess || connectError"
            cols="12"
            class="mb-8 mt-2"
          >
            <v-card
              class="d-flex flex-row align-center justify-center"
              width="100%"
              height="20px"
              elevation="0"
            >
              <v-progress-circular
                v-if="connectLoading"
                width="2"
                size="18"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <v-icon v-if="connectSuccess" color="#3A9020">mdi-check</v-icon>
              <v-icon v-if="connectError" color="#8B0A06">mdi-close</v-icon>
            </v-card>
          </v-col>
          <v-row no-gutters class="mb-6 mt-6">
            <v-col cols="3" class="my-auto">
              <span class="body-bold-smaller textType6--text">{{
                $t('message.pages.videoPlayerForm.platform')
              }}</span>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="platform"
                :items="platforms"
                dense
                item-text="text"
                item-value="value"
                :placeholder="placeholders.selectOption"
                outlined
                hide-details
              ></v-select>
            </v-col>
          </v-row>
          <v-row no-gutters class="mb-6">
            <v-col cols="3" class="my-auto">
              <span class="body-bold-smaller textType6--text">{{
                platform === 'webhook' || platform === 'mailchimp'
                  ? platform === 'mailchimp'
                    ? $t('message.pages.videoPlayerForm.nameList')
                    : $t('message.pages.videoPlayerForm.name')
                  : $t('message.pages.videoPlayerForm.apiUrl')
              }}</span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="apiUrl"
                :placeholder="apiUrlPlaceholder"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="platform !== 'clickmax'" no-gutters class="mb-2">
            <v-col cols="3" class="my-auto">
              <span class="body-bold-smaller textType6--text">{{
                platform === 'webhook'
                  ? $t('message.pages.videoPlayerForm.webhookUrl')
                  : $t('message.pages.videoPlayerForm.apiKey')
              }}</span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="apiKey"
                :placeholder="apiKeyPlaceholder"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-8 pb-6 mt-6 d-flex justify-end">
        <base-btn
          type="tertiary"
          class="mr-2"
          @click="handleClose"
          :disabled="loading"
        >
          <span class="mx-3">{{
            $t('message.pages.externalSourceVideo.cancel')
          }}</span>
        </base-btn>
        <base-btn
          :loading="loading"
          :disabled="!isValidForSave"
          @click="handleConnect"
          :tooltip="!isValidForSave ? getValidationMessage : ''"
        >
          <span class="mx-3">
            {{ $t('message.pages.videoPlayerForm.conect') }}
          </span>
        </base-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import integrationsApi from '@/services/integrationsApi'
import { mapMutations } from 'vuex'

export default {
  name: 'VideoPlayerFormModal',
  data: () => ({
    open: false,
    loading: false,
    platform: 'clickmax',
    apiUrl: '',
    apiKey: '',
    platforms: [
      { text: 'ActiveCampaign', value: 'active_campaign' },
      { text: 'Mailchimp', value: 'mailchimp' },
      { text: 'Webhook', value: 'webhook' },
      // { text: 'ClickMax', value: 'clickmax' },
    ],
    integrationsList: [],
    connectLoading: false,
    connectError: false,
    connectSuccess: false,
    isEdit: false,
    placeholders: {
      selectOption: '',
      listName: '',
      name: '',
      apiUrl: '',
      webhookUrl: '',
      apiKey: '',
    },
  }),
  computed: {
    locale() {
      return this.$i18next.resolvedLanguage
    },
    apiUrlPlaceholder() {
      if (this.platform === 'mailchimp') {
        return this.placeholders.listName
      } else if (this.platform === 'webhook') {
        return this.placeholders.name
      } else {
        return this.placeholders.apiUrl
      }
    },
    apiKeyPlaceholder() {
      if (this.platform === 'webhook') {
        return this.placeholders.webhookUrl
      } else {
        return this.placeholders.apiKey
      }
    },
    isValidForSave() {
      // Verificar se a plataforma foi selecionada
      if (!this.platform || this.platform.trim() === '') {
        return false
      }

      // Verificar se a URL/API está preenchida
      if (!this.apiUrl || this.apiUrl.trim() === '') {
        return false
      }

      // Para plataformas que não são clickmax, verificar se a API key está preenchida
      if (this.platform !== 'clickmax') {
        if (!this.apiKey || this.apiKey.trim() === '') {
          return false
        }
      }

      return true
    },
    getValidationMessage() {
      if (!this.platform || this.platform.trim() === '') {
        return this.$t('message.requiredFill')
      }
      if (!this.apiUrl || this.apiUrl.trim() === '') {
        return this.$t('message.requiredFill')
      }
      if (
        this.platform !== 'clickmax' &&
        (!this.apiKey || this.apiKey.trim() === '')
      ) {
        return this.$t('message.requiredFill')
      }
      return ''
    },
  },
  watch: {
    platform: {
      handler() {
        this.fixIntegrationFields()
      },
      deep: true,
    },
    locale: {
      handler() {
        this.updateText()
      },
      immediate: true,
    },
  },
  mounted() {
    this.$root.$on('changeLanguage', this.updateText)
    this.$root.$on('openVideoPlayerFormModal', (integration, integrations) => {
      this.resetData()
      this.resetErrorsAndLoadings()
      this.integrationsList = integrations
      if (integration) {
        this.isEdit = true
        let integrationName = integration.service
        this.platform = integration.service
        if (integrationName === 'active_campaign') {
          this.apiUrl = integration.metadata.api_url
          this.apiKey = integration.metadata.api_key
        }
        if (integrationName === 'mailchimp') {
          this.apiUrl = integration.metadata.name
          this.apiKey = integration.metadata.api_key
        }
        if (integrationName === 'webhook') {
          this.apiUrl = integration.metadata.name
          this.apiKey = integration.metadata.webhook_url
        }
      }
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('changeLanguage')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    getIntegrationName(serviceName) {
      if (serviceName === 'mailchimp') {
        return 'Mailchimp'
      } else if (serviceName === 'active_campaign') {
        return 'Active Campaign'
      } else if (serviceName === 'webhook') {
        return 'Webhook'
      } else if (serviceName === 'clickmax') {
        return 'ClickMax'
      } else {
        return '-'
      }
    },
    updateText() {
      // Atualizar os textos dos placeholders e labels que dependem de tradução
      this.platforms = [
        { text: 'ActiveCampaign', value: 'active_campaign' },
        { text: 'Mailchimp', value: 'mailchimp' },
        { text: 'Webhook', value: 'webhook' },
        // { text: 'ClickMax', value: 'clickmax' },
      ]

      // Atualizar placeholders dinamicamente
      this.placeholders = {
        selectOption: this.$t(
          'message.pages.videoPlayerForm.placeholders.selectOption'
        ),
        listName: this.$t(
          'message.pages.videoPlayerForm.placeholders.listName'
        ),
        name: this.$t('message.pages.videoPlayerForm.placeholders.name'),
        apiUrl: this.$t('message.pages.videoPlayerForm.placeholders.apiUrl'),
        webhookUrl: this.$t(
          'message.pages.videoPlayerForm.placeholders.webhookUrl'
        ),
        apiKey: this.$t('message.pages.videoPlayerForm.placeholders.apiKey'),
      }

      // Forçar atualização do template para refletir as mudanças de idioma
      this.$forceUpdate()
    },
    fixIntegrationFields() {
      let integrationName = this.platform
      let integrations = this.integrationsList || []
      let existantItem = integrations.find(
        (item) => item.service === integrationName
      )
      if (existantItem) {
        if (integrationName === 'active_campaign') {
          this.apiUrl = existantItem.metadata.api_url
          this.apiKey = existantItem.metadata.api_key
        }
        if (integrationName === 'mailchimp') {
          this.apiUrl = existantItem.metadata.name
          this.apiKey = existantItem.metadata.api_key
        }
        if (integrationName === 'webhook') {
          this.apiUrl = existantItem.metadata.name
          this.apiKey = existantItem.metadata.webhook_url
        }
        if (integrationName === 'clickmax') {
          this.apiUrl = existantItem.metadata.api_url
        }
      } else {
        this.apiKey = ''
        this.apiUrl = ''
      }
    },
    resetData() {
      this.platform = ''
      this.apiUrl = ''
      this.apiKey = ''
      this.integrationsList = []
      this.isEdit = false
    },
    resetErrorsAndLoadings() {
      this.connectLoading = false
      this.connectSuccess = false
      this.connectError = false
    },
    async handleConnect() {
      let integrationName = this.platform
      let integrationObject = {}
      if (integrationName === 'active_campaign') {
        integrationObject = {
          service: 'active_campaign',
          api_url: this.apiUrl,
          api_key: this.apiKey,
        }
      }
      if (integrationName === 'mailchimp') {
        integrationObject = {
          service: 'mailchimp',
          name: this.apiUrl,
          api_key: this.apiKey,
        }
      }
      if (integrationName === 'webhook') {
        integrationObject = {
          service: 'webhook',
          name: this.apiUrl,
          webhook_url: this.apiKey,
        }
      }
      if (integrationName === 'clickmax') {
        integrationObject = {
          service: 'clickmax',
          api_url: this.apiUrl,
        }
      }
      this.resetErrorsAndLoadings()
      let integrations = this.integrationsList || []
      let existantItem = integrations.find(
        (item) => item.service === integrationName
      )
      if (existantItem) {
        try {
          this.connectLoading = true
          integrationObject['id'] = existantItem.id
          await integrationsApi.updateIntegration(integrationObject)
          this.connectSuccess = true
          this.connectLoading = false
          this.handleSnackbar(
            `${this.$t(
              'message.pages.videoPlayerForm.integrationSuccessPart1'
            )} ${this.getIntegrationName(integrationName)} ${this.$t(
              'message.pages.videoPlayerForm.integrationSuccessPart2'
            )}`
          )
          this.$root.$emit('reloadIntegrations')
          this.handleClose()
        } catch (e) {
          console.error('Error updating integration:', e)
          this.connectLoading = false
          this.connectError = true
          this.handleErrorSnackbar(this.$t('message.errors.unexpectedError'))
        }
      } else {
        try {
          this.connectLoading = true
          await integrationsApi.saveIntegration(integrationObject)
          this.connectSuccess = true
          this.connectLoading = false
          this.handleSnackbar(
            `${this.$t(
              'message.pages.videoPlayerForm.integrationSuccessPart1'
            )} ${this.getIntegrationName(integrationName)} ${this.$t(
              'message.pages.videoPlayerForm.integrationSuccessPart2'
            )}`
          )
          this.$root.$emit('reloadIntegrations')
          this.handleClose()
        } catch (e) {
          console.error('Error saving integration:', e)
          this.connectLoading = false
          this.connectError = true
          this.handleErrorSnackbar(this.$t('message.errors.unexpectedError'))
        }
      }
    },
    handleClose() {
      this.open = false
    },
    handleSnackbar(item) {
      if (!item) {
        item = this.$t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
    handleErrorSnackbar(errorMsg) {
      console.log('errorMsg', errorMsg)
      this.handleErrorSnackbar(this.$t('message.errors.unexpectedError'))
    },
  },
}
</script>
